/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.06.17.
 */

import BaseFormatter from "./BaseFormatter";

class EnumFormatter extends BaseFormatter {
    /**
     *
     * @param {Schema} schema
     * @param {Array} params
     */
    constructor(schema, params) {
        super(schema, params);

        this.enum = schema.getEnum();
        this.enumNames = schema.getEnumNames();
        if (params && params.length > 1) {
            this.enum = params[0];
            this.enumNames = params[1];
        }
    }

    format(value) {
        if (!this.enum) return "";

        for (let i = 0; i < this.enum.length; i++) {
            if (value === this.enum[i]) return this.enumNames[i];
        }
        if (value == null) return "";
        return value.toString();
    }
}

export default EnumFormatter;
